import type { ReactNode } from 'react';

/**
 * docs/DESIGN_SYSTEM.md §4.6 — bg-surface container, uppercase micro header
 * on bg-base (one step darker to anchor it), horizontal-only row dividers,
 * dense (36px) rows by default, hover on bg-elevated. Used for ticket
 * queues, moderation case history, log search results, etc.
 */
export function Table({ children }: { children: ReactNode }) {
  return (
    <div className="bg-bg-surface border border-border-subtle rounded-md overflow-hidden overflow-x-auto">
      <table className="w-full text-left border-collapse min-w-[480px]">{children}</table>
    </div>
  );
}

export function TableHead({ children }: { children: ReactNode }) {
  return (
    <thead className="bg-bg-base">
      <tr>{children}</tr>
    </thead>
  );
}

export function TableHeaderCell({ children }: { children: ReactNode }) {
  return (
    <th className="text-micro uppercase text-text-tertiary font-medium px-4 py-2.5 text-left">
      {children}
    </th>
  );
}

export function TableBody({ children }: { children?: ReactNode }) {
  return <tbody className="divide-y divide-border-subtle">{children}</tbody>;
}

export function TableRow({ children }: { children: ReactNode }) {
  return <tr className="hover:bg-bg-elevated transition-colors">{children}</tr>;
}

export function TableCell({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <td className={['px-4 py-2.5 text-body text-text-primary align-middle', className].join(' ')}>{children}</td>;
}
